import { JsonEntity, SgvJson } from '@eceos/arch';

export class SupportGenerateBankSlipRequest implements JsonEntity {
  constructor(
    public receivableId = '',
    public bankSlipWalletId = '',
    public value: number = 0,
    public expirationDate: Date = new Date()
  ) {}

  toJson() {
    return SgvJson.to.simple(this, {
      expirationDate: this.expirationDate ? this.expirationDate.toISOString().split('T')[0] : null
    });
  }
}
